// LivestreamOverlayChatroom.js
'use strict';
import { connect } from 'react-redux';

import LivestreamOverlayChatroom from '../component/LivestreamOverlayChatroom.jsx';
import getLiveStreamChats from '../selector/getLiveStreamChats.js';

const mapStateToProps = (state, { streamId }) => {
  const chatIds = getLiveStreamChats(state, streamId);
  return { chatIds };
};

export default connect(mapStateToProps, null)(LivestreamOverlayChatroom);
